import * as CONST from '../ActionTypes';

const initialState = {
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  ecInformation: {},
  ecInformationList: [],
};

function ecInformation(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // EC情報一覧取得
    // -----------------
    case CONST.GET_EC_INFORMATION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          ecInformationList: action.payload,
        },
      );
    case CONST.GET_EC_INFORMATION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isFailure: true,
          ecInformationList: {},
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_EC_INFORMATION_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default ecInformation;
